<template>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="700">
      <v-card>
        <v-card-title class="headline">
          <v-icon left color="warning">mdi-alert</v-icon>
          Confirm Cancellation
        </v-card-title>

        <v-card-text>
          <v-alert type="warning" dense class="mb-4">
            Are you sure you want to cancel your {{ planName }} subscription?
          </v-alert>

          <p class="subtitle-1">Please note the following:</p>

          <v-list dense>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="info">mdi-calendar-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Your {{ planName }} status will remain active until {{ formattedEndDate }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="success">mdi-shield-check</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  You'll continue to have access to all {{ planName }} features until this date
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="primary">mdi-currency-usd-off</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  You will not be charged again unless you reactivate your subscription
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="user.is_pro_team">
              <v-list-item-icon>
                <v-icon color="warning">mdi-account-group-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  All {{ teamSize }} team member{{ teamSize !== 1 ? 's' : '' }} will lose access at the end of the billing period
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-icon>
                <v-icon color="success">mdi-restore</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  You can reactivate anytime before {{ formattedEndDate }} to maintain uninterrupted access
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider class="my-4"></v-divider>

          <div class="text-body-2 text--secondary">
            If you're experiencing any issues or have concerns about your subscription,
            please contact our support team before canceling. We're here to help!
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            text
            @click="$emit('input', false)"
            :disabled="loading"
          >
            <v-icon left>mdi-check</v-icon>
            Keep Subscription
          </v-btn>
          <v-btn
            color="error"
            text
            @click="$emit('confirm')"
            :loading="loading"
          >
            <v-icon left>mdi-cancel</v-icon>
            Confirm Cancellation
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>

  <script>
  export default {
    name: 'CancellationDialog',

    props: {
      value: {
        type: Boolean,
        default: false,
      },
      user: {
        type: Object,
        required: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      planName() {
        return this.user.is_pro_team ? 'Pro Team' : 'Pro';
      },

      teamSize() {
        return this.user.team_size || 0;
      },

      formattedEndDate() {
        if (!this.user.subscription_end_date) return '';
        return new Date(this.user.subscription_end_date).toLocaleDateString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
      },
    },
  };
  </script>
